export enum Mandatory2FAStepName {
  Introduction = "introduction",
  PhoneNumber = "phoneNumber",
  ActivateTotp = "activateTotp",
  TotpRecoveryCodes = "totpRecoveryCodes",
}
